import React, { useMemo } from 'react'
import styled from 'styled-components'
import { TCarDict, TCarList } from '../../../../../../models/Defaults/carList'
import { ITransportAreaDict } from '../../../../../../models/Defaults/transportArea'
import { TOrderList } from '../../../../../../models/RequestsModel/orderModel'
import { TPalletForTransferList } from '../../../../../../models/RequestsModel/palletsForTransfer'
import TitlesList from '../../../../../generic/titlesRowItem/TitlesList'
import RowElement from './RowElement'
import { ICustomerItem, IKavDataItem } from '../../../../../modules/API/Drivers/models/kavData'


type Props = {
    carList: TCarList,
    carsDict: TCarDict,
    orderTree: IKavDataItem[],
    transportAreaDict: ITransportAreaDict,
    ignorDirection: number
}

interface IKavItem {
    CustomerID: number | undefined,
    NetWeight: number,
    OrderPallets: IOrderItem[],
    PalletTransferZone: number
}

interface IOrderItem {
    Custom: boolean,
    CustomerID: number,
    Customer_Name: string,
    OrderID: number,
    PalletsQty: number,
    Products: number,
    Status: number,
    Width: number | null | undefined,
    pallets: TPalletForTransferList
}

export interface ICollectDataOutput {
    CarNum: number,
    Detailes: ICollectDataDetailesItem[],
    DriverName: string
}

interface ICollectDataDetailesItem {
    AreaDesc: string,
    DriverName: string,
    MaxFillCarByPallets: number
    PalletsQty: number
    TotalWidth: number
    UniqPoints: number
}

export interface ITitleItemP {
    $isLong?: boolean | undefined
    $length?: number,
    $border?: boolean
}
const MainContainer = styled.div`
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 10px;
    padding: 0.5em;
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    gap: 0.5em;
    overflow: auto;
    z-index: 99;
    &::-webkit-scrollbar {
        width: 0;
    }
`
export const TitleWrapper = styled.div<ITitleItemP>`
    width: 100%;
    min-height: ${props => props.$length ? `${props.$length * 1.9}em`: '3em'};
    border-radius: 10px;
    background: #eff3f4;
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;
    align-items: center;
    padding: 0 0.5em;
`
export const TitleItem = styled.div<ITitleItemP>`
    flex: 0 0 ${props => props.$isLong ? '18%' : '13%'};
    max-width: ${props => props.$isLong ? '18%' : '13%'};
    display: flex;
    flex-flow: column;
    align-items: flex-end;
    color: #297f76;
    font-weight: 600;
    border-left: ${props => props.$border ? '2px solid #297f76' : 'none'} ;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

const StatisticTable = ({carList, orderTree, transportAreaDict, carsDict, ignorDirection}: Props) => {
    const collectData = (): ICollectDataOutput[] => {
        const reduced = orderTree.reduce((acc: Record<number, ICollectDataOutput>, cur) => {
            if (cur.AreaID === 0 || cur.AreaID === ignorDirection) return acc
            let carID = cur.CarId
            let objectConstructor = {
                AreaDesc: cur.AreaDesc?.trim(),
                DriverName: carsDict[carID]?.DriverName?.trim(),
                TotalWidth: 0,
                PalletsQty: currentCarPallets(cur.Customers),
                MaxFillCarByPallets: carsDict[carID]?.Pallets || 0,
                UniqPoints: clientsQty(cur.Customers)
            }
            acc[carID] = {
                DriverName: carsDict[carID]?.DriverName?.trim() || 'empty data',
                CarNum:carsDict[carID]?.CarNum || 0,
                Detailes: acc[carID] ?  [...acc[carID].Detailes, objectConstructor] : [objectConstructor]
            }
            // console.log(acc)
            return acc
        }, {})

        return Object.values(reduced)
    }

    const dataSet = useMemo(() => collectData(), [orderTree])
  return (
    <MainContainer>
        <TitleWrapper>
            <TitleItem $border $isLong>רכב</TitleItem>
            <TitleItem $border>מספר משאית</TitleItem>
            <TitleItem $border $isLong>קו</TitleItem>
            <TitleItem $border>מספר נקודות</TitleItem>
            <TitleItem $border>משטחים</TitleItem>
            <TitleItem>ניצול משאית</TitleItem>
        </TitleWrapper>
        <TitlesList
            list={dataSet}
            uniqueKey={'CarNum'}
            Element={RowElement}
            noPadding
        />
    </MainContainer>
  )
}

export default StatisticTable

const clientsQty = (orders: ICustomerItem[]) => {
    let reduced = orders.reduce((acc: number[], cur) => {
        acc = acc.concat(cur.CustomerID)
        return acc
    }, [])
    const newSet = new Set(reduced)
    return newSet.size
}

export const currentCarPallets = (orders: ICustomerItem[]) => {
    const ordersAllowToShow = [4,7,9]

    let generalPalletQty = orders.reduce((acc, cur) => {
        const result = 
            cur.Orders.reduce((accO, curO) => {
                if(ordersAllowToShow.includes(curO.Status)) {
                    return accO + curO.PalletsList.reduce((accP, curP) => {
                        return accP + curP.PallQty
                    }, 0)
                }
                return accO + Math.ceil(curO.Pallets)
            }, 0)

        return acc + result
    }, 0)
    return Math.round(generalPalletQty)
}